import React from 'react';
import { Link } from 'react-router-dom';

// components
import Menu from './Menu';


class Header extends React.Component {
	constructor(props) {
		super(props);
		this.navMobileToggle = this.navMobileToggle.bind(this);
		this.navShrinker = this.navShrinker.bind(this);
	}

	navMobileToggle() {
		const body = document.body;
		const menuButton = document.querySelector('.menu-toggle');
		const siteHeader = document.querySelector('.siteHeader');

		menuButton.addEventListener("click", function() {
			var siteHeaderAttribute = siteHeader.attributes["data-expanded"].value;

			body.classList.toggle('js-noScroll');

			if(siteHeaderAttribute === "false") {
				siteHeader.setAttribute('data-expanded', 'true');
				menuButton.setAttribute('aria-label', 'Close');
			} else {
				siteHeader.setAttribute('data-expanded', 'false');
				menuButton.setAttribute('aria-label', 'Open');
			}
		});
	}

	// Shrinks the nav height once scrolled from top of page
	navShrinker() {
		var windowScrollTop = window.scrollY;
		const body = document.querySelector('body');
		const nav = document.querySelector('.siteHeader');
		const navHeight = nav.offsetHeight;

		// initial check in case the page is loaded lower down
		if(windowScrollTop > navHeight / 4) {
			body.classList.add('js-shrunkNav');
			nav.classList.add('js-noTransition');

			setTimeout(()=>{
				nav.classList.remove('js-noTransition');
			}, 1);

			nav.addEventListener("transitionend", ()=> {
				nav.classList.remove('js-noTransition');
			}, false);
		}

		// Check whether or not we need to hide nav with every scroll
		window.addEventListener('scroll', ()=> {
			windowScrollTop = window.scrollY;

			// Scroll direction check, also don't hide until we're at least beyond
			// the nav height.
			if(windowScrollTop > navHeight / 4) {
				body.classList.add('js-shrunkNav');
			} else if(windowScrollTop <= navHeight) {
				body.classList.remove('js-shrunkNav');
			}	
		});
	}

	componentDidMount() {
		this.navShrinker();
		this.navMobileToggle();
	}

	render() {
		return (
			<header className="siteHeader" data-expanded="false">
				<div className="siteHeader--container">
					<Link to="/" className="homeLink"><img src="/img/cgh-logo.svg" alt="CGH logo"/></Link>
					<nav>
						<button aria-controls="primary-menu" aria-label="Open" className="menu-toggle">
							<span></span>
							<span></span>
							<span></span>
						</button>
						<Menu pathname={this.props.location.pathname} />
					</nav>
				</div>
			</header>
		)
	}
}

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/